import * as React from "react";

import theme from "@ui/themes/default";

import { style, Icon } from "./Symbolicons";

export const Shower = (props: Icon): React.ReactElement => {
  if (props.variant === "line") {
    return (
      <svg
        viewBox="0 0 24 24"
        style={{ ...style(props.size, props.height), ...props.style }}
        className={props.className}
      >
        <path
          d="M3 12V3.605A2.606 2.606 0 0 1 7.773 2.16m5.477 1.09l-6 4m2-5.167l-2 1.334M21 12v5a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4v-5m2 11v-2.535M18.96 23v-2.535M19 23v-2.535M1 12h22"
          stroke={props.color || theme.palette.grey600}
          strokeWidth={2}
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }

  return (
    <svg
      viewBox="0 0 24 24"
      style={{ ...style(props.size, props.height), ...props.style }}
      className={props.className}
    >
      <path
        d="M2.001 18.001c0 1.477.809 2.752 2 3.445v1.555a1 1 0 1 0 2 0v-1h12v1a1 1 0 1 0 2 0v-1.555c1.191-.693 2-1.969 2-3.445v-3h-20v3zm21-7h-19V3.473c0-.812.66-1.472 1.472-1.472.492 0 .93.249 1.202.646a3.782 3.782 0 0 0-.08 4.19l6.406-4.076a3.765 3.765 0 0 0-4.78-1.4A3.446 3.446 0 0 0 5.473.002a3.477 3.477 0 0 0-3.472 3.472v7.527h-1c-.55 0-1 .45-1 1s.45 1 1 1h22c.55 0 1-.45 1-1s-.45-1-1-1z"
        fill={props.color || theme.palette.grey600}
        fillRule="nonzero"
      />
    </svg>
  );
};
